const makeRadiusMenu = (widgetOptions) => {
  const { container } = widgetOptions;
  let { items } = widgetOptions;

  const updateItemsWithValue = (value) => {
    items = items.map((item) => {
      item.isRefined = false;

      if (item.value === value) {
        item.isRefined = true;
      }

      return item;
    });
  };

  const init = (options) => {
    const { helper } = options;

    container.addEventListener('change', (event) => {
      helper.setQueryParameter('aroundRadius', event.target.value).search();
    });
  };

  const render = (options) => {
    options.items = items;
    container.innerHTML = makeSelect(options);
  };

  const getWidgetState = (uiState, widgetStateOptions) => {
    const radius = widgetStateOptions?.searchParameters?.aroundRadius;

    updateItemsWithValue(radius);

    if (radius) {
      uiState.aroundRadius = radius;
    }

    return uiState;
  };

  const getWidgetSearchParameters = (searchParameters, options) => {
    if (!Boolean(options?.uiState?.aroundRadius)) {
      return searchParameters;
    }

    searchParameters.aroundRadius = parseInt(options.uiState.aroundRadius);

    return searchParameters;
  };

  return {
    init,
    render,
    getWidgetState,
    getWidgetSearchParameters,
  };
};

const makeSelect = (renderOptions) => {
  const { instantSearchInstance, items } = renderOptions;

  if (!isLocationSearch(instantSearchInstance)) {
    return '';
  }

  return html`
    <div class="px-4 py-5 bg-white border-b border-gray-200 sm:px-6">
      <div class="relative rounded-md shadow-sm">
        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <span class="text-gray-500 sm:text-sm"> Within </span>
        </div>

        <select
          name="search_radius"
          aria-label="Search Radius"
          class="block w-full pl-20 transition border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-primary-200 focus:ring-opacity-50 focus:border-primary-300 sm:pl-16 sm:text-sm"
        >
          ${items.map(
            (item) => html`
              <option value="${item.value}" ${item.isRefined ? `selected` : ``}>
                ${item.label}
              </option>
            `
          )}
        </select>
      </div>
    </div>
  `;
};

const isLocationSearch = (instantSearchInstance) =>
  Boolean(instantSearchInstance?.helper?.state?.aroundLatLng);

export const radius = (widgetOptions) =>
  makeRadiusMenu({
    items: [
      { label: 'Any distance', value: 'all' },
      { label: '5 Miles', value: 8046 },
      { label: '20 Miles', value: 32186 },
      { label: '50 Miles', value: 80467 },
      { label: '100 Miles', value: 160934 },
    ],
    ...widgetOptions,
  });
